import moment from "moment";
import {
  ALL_ADJUSTMENTS,
  IC_REPLACE,
  DAMAGES,
  SHORT_MARKED_OUT_OF_STOCK,
  KNOWN_THEFT,
  SHIPMENT,
  CANDY,
  BROKEN,
  NO_PACKAGING_UNSELLABLE,
  CUSTOMER_RETURN,
  ECOM_RETURN,
  FLOODING_PESTS_NATURAL_DISASTER,
  WOWTOWN_DIRECTED_MOS,
  IN_STORE_EVENT_AND_PRIZES,
  TESTERS_AND_DISPLAYS,
  CUSTOMER_ACCOMMODATION,
  WOWCREW_SNACKS_AND_RECOGNITION,
  EXPIRED_PRODUCT,
  DEFECTIVE_PRODUCT,
  FOUND_PACKAGING,
  OBSERVED_THEFT,
  RECEIVED_DAMAGED,
  RECEIVED_EXPIRED,
  CANDY_SHORT_SHIPPED,
  CANDY_OVER_SHIPPED,
  ALL_REASON_CODE,
  TREND,
  MTD,
  YESTERDAY,
  LCW,
  WTD,
} from "../common/constants";

const matrixDateRange = (name) => {
  const todate = () => moment().subtract(1, "day").format("YYYY-MM-DD");
  const ranges = {
    LCW: () => ({
      fromdate: moment().subtract(7, "day").format("YYYY-MM-DD"),
      todate: todate(),
    }),
    WTD: () => ({
      fromdate: moment().subtract(7, "day").format("YYYY-MM-DD"),
      todate: todate(),
    }),
    MTD: () => ({
      fromdate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      todate: todate(),
    }),
    QTD: () => ({
      fromdate: moment().subtract(3, "month").format("YYYY-MM-DD"),
      todate: todate(),
    }),
    YTD: () => ({
      fromdate: moment().subtract(1, "year").format("YYYY-MM-DD"),
      todate: todate(),
    }),
  };
  const pick = ranges[name];
  return pick ? pick() : null;
};

export const getDate = (name, type) => {
  if (name === "YESTERDAY") {
    return moment().subtract(1, "day").format("YYYY-MM-DD");
  }
  const range = matrixDateRange(name);
  if (!range) {
    return;
  }
  if (type === "fromdate") {
    return range.fromdate;
  }
  if (type === "todate") {
    return range.todate;
  }
};

export const getDropdownOptions = () => {
  const yesterday = new Date();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  yesterday.setDate(yesterday.getDate() - 1);
  const yday = `${monthNames[yesterday.getMonth()]
    } ${yesterday.getDate()}, ${yesterday.getFullYear()}`;
  return [
    { value: "YESTERDAY", label: yday },
    { value: "WTD", label: "Week To Date" },
    { value: "LCW", label: "Last Complete Week" },
    { value: "MTD", label: "Month To Date" },
    { value: "QTD", label: "Quarter To Date" },
    { value: "YTD", label: "Year To Date" },
  ];
};

export const getLaborDropdownOptions = () => {
  return [
    { value: "LCW", label: "Last Complete Week" },
    { value: "MTD", label: "Month To Date" },
    { value: "QTD", label: "Quarter To Date" },
    { value: "YTD", label: "Year To Date" },
  ];
};

export const getTrendDropdownOptions = () => {
  return [
    { value: "MTD", label: "Month To Date" },
    { value: "QTD", label: "Quarter To Date" },
    { value: "YTD", label: "Year To Date" },
  ];
};

export const getSalesTrendDropdownOptions = () => {
  return [
    { value: "LCW", label: "Last Complete Week" },
    { value: "WTD", label: "Week To Date" },
    { value: "MTD", label: "Month To Date" },
    { value: "QTD", label: "Quarter To Date" },
    { value: "YTD", label: "Year To Date" },
  ];
};

export const getInventoryTrendDropdownOptions = () => {
  return [
    { value: "LCW", label: "Last Complete Week" },
    { value: "MTD", label: "Month To Date" },
  ];
};

export const round = (num) => {
  const m = Number((Math.abs(num) * 100).toPrecision(15));
  return Math.sign(num) === -1
    ? `(${Math.round(m) / 100}%)`
    : `${(Math.round(m) / 100) * Math.sign(num)}%`;
};

export const roundValue = (e, currencyCode) => {
  if (e) {
    const absValue = Math.abs(Math.round(e));
    const returnString = absValue.toLocaleString("en");
    if (currencyCode) {
      return e < 0 ? "( $ " + returnString + ")" : "$ " + returnString;
    } else return e < 0 ? "(" + returnString + ")" : returnString;
  } else {
    return currencyCode ? "$ 0" : "0";
  }
};

export const toTitleCase = (str) => {
  return str?.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
export const getInitials = (nameString) => {
  const fullName = nameString.split(" ");
  let initials = "";
  if (fullName.length === 1) {
    initials = fullName[0].charAt(0).toUpperCase();
  } else {
    initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
  }
  return initials.toUpperCase();
};

const hasToFixedValue = (e) => e != null && e !== "" && Boolean(e);

const formatAbsoluteLocale = (value, digit) => {
  const absValue = Math.abs(value);
  if (digit === 1) {
    return absValue.toLocaleString(undefined, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
  }
  if (digit === 2) {
    return absValue.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return absValue.toLocaleString(undefined, {
    maximumFractionDigits: 0,
  });
};

const TYPE_POSITION_FORMATTERS = {
  start: (type, str, neg) =>
    neg ? "( " + type + " " + str + ")" : "" + type + " " + str,
  end: (type, str, neg) =>
    neg ? "(" + str + " " + type + ")" : str + " " + type,
  start_nospace: (type, str, neg) =>
    neg ? "( " + type + "" + str + ")" : "" + type + "" + str,
  end_nospace: (type, str, neg) =>
    neg ? "(" + str + "" + type + ")" : str + "" + type,
};

export const toFixedVal = (e, type, pos, digit) => {
  if (!hasToFixedValue(e)) return 0;

  const formatted = formatAbsoluteLocale(e, digit);
  if (!type) return e < 0 ? "( " + formatted + ")" : formatted;

  const format = TYPE_POSITION_FORMATTERS[pos] ?? TYPE_POSITION_FORMATTERS.start;
  return format(type, formatted, e < 0);
};

export const nullCheck = (e) => {
  if (e && e !== undefined && e !== "" && e !== null) {
    return e?.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  } else {
    return " ";
  }
};

export const chartValue = (e) => {
  if (e && e !== undefined && e !== null && e !== "") {
    let returnString = Math.abs(e).toFixed(2);
    return e < 0 ? "-" + returnString : returnString;
  } else {
    return "0";
  }
};

const roleOptionsForDm = () => [
  { label: "District Manager", value: "DM" },
  { label: "Store Manager", value: "SM" },
];

const roleOptionsForRd = () => [
  { label: "Regional Director", value: "RD" },
  { label: "District Manager", value: "DM" },
  { label: "Store Manager", value: "SM" },
];

const roleOptionsForSm = () => [{ label: "Store Manager", value: "SM" }];

export const getRoleDropDownOptions = (staticUserRole) => {
  if (staticUserRole.includes("DM")) {
    return roleOptionsForDm();
  }
  if (staticUserRole.includes("RD")) {
    return roleOptionsForRd();
  }
  if (staticUserRole.includes("SM")) {
    return roleOptionsForSm();
  }
  return [];
};

export const getStoreChecker = (n) => {
  return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
};

export const getLocationStateToken = (primarylocation) => {
  if (!primarylocation) {
    return "";
  }
  return primarylocation.split(/\s*[\s,]\s*/).pop() ?? "";
};

export const getLocationNameWithoutState = (primarylocation) => {
  if (primarylocation === "NA") {
    return "NA";
  }
  const statelocation = getLocationStateToken(primarylocation);
  if (statelocation.length === 2) {
    return primarylocation?.slice(0, primarylocation.lastIndexOf(","));
  }
  return primarylocation;
};

export const resolveOmniServicesDropdownValue = (activeTab, selectedDate) => {
  if (
    selectedDate === YESTERDAY ||
    selectedDate === LCW ||
    selectedDate === WTD
  ) {
    return activeTab === TREND ? MTD : selectedDate;
  }
  if (activeTab === TREND && selectedDate === MTD) {
    return MTD;
  }
  if (selectedDate) {
    return selectedDate;
  }
  return activeTab === TREND ? MTD : YESTERDAY;
};

export const MARKED_OUT_OF_STOCK_OPTIONS = [
  { label: ALL_ADJUSTMENTS, value: ALL_ADJUSTMENTS },
  { label: "05 - MOS – Exp.", value: "05 - MOS – Exp." },
  { label: "06 - MOS – Str. Use", value: "06 - MOS – Str. Use" },
  { label: "07 - MOS – WT Dir.", value: "07 - MOS – WT Dir." },
  { label: "08 - MOS – WOW", value: "08 - MOS – WOW" },
];

export const getICMerchAdj_CodeDropdownOptions = [
  { label: ALL_ADJUSTMENTS, value: ALL_ADJUSTMENTS },
  { label: IC_REPLACE, value: "REPLACE" },
  { label: DAMAGES, value: "DAMAGE" },
  { label: SHORT_MARKED_OUT_OF_STOCK, value: SHORT_MARKED_OUT_OF_STOCK },
  { label: KNOWN_THEFT, value: "KNOWN THEFT" },
  { label: SHIPMENT, value: "SHIPMENT" },
  { label: CANDY, value: 'CANDY' },
];
export const getDefaultReasonCodeOption = [
  { label: ALL_REASON_CODE, value: ALL_REASON_CODE },
];
export const getReasonCodeOptions_Replace = [
  { label: IC_REPLACE, value: IC_REPLACE },
];
export const getReasonCodeOptions_Damage = [
  { label: BROKEN, value: BROKEN },
  { label: NO_PACKAGING_UNSELLABLE, value: NO_PACKAGING_UNSELLABLE },
  { label: CUSTOMER_RETURN, value: CUSTOMER_RETURN },
  { label: ECOM_RETURN, value: ECOM_RETURN },
  {
    label: FLOODING_PESTS_NATURAL_DISASTER,
    value: FLOODING_PESTS_NATURAL_DISASTER,
  },
];
export const getReasonCodeOptions_MOS = [
  { label: WOWTOWN_DIRECTED_MOS, value: WOWTOWN_DIRECTED_MOS },
  { label: IN_STORE_EVENT_AND_PRIZES, value: IN_STORE_EVENT_AND_PRIZES },
  { label: TESTERS_AND_DISPLAYS, value: TESTERS_AND_DISPLAYS },
  { label: CUSTOMER_ACCOMMODATION, value: CUSTOMER_ACCOMMODATION },
  {
    label: WOWCREW_SNACKS_AND_RECOGNITION,
    value: WOWCREW_SNACKS_AND_RECOGNITION,
  },
  { label: EXPIRED_PRODUCT, value: EXPIRED_PRODUCT },
  { label: DEFECTIVE_PRODUCT, value: DEFECTIVE_PRODUCT },
];
export const getReasonCodeOptions_KT = [
  { label: FOUND_PACKAGING, value: FOUND_PACKAGING },
  { label: OBSERVED_THEFT, value: OBSERVED_THEFT },
];
export const getReasonCodeOptions_Shipment = [
  { label: RECEIVED_DAMAGED, value: RECEIVED_DAMAGED },
  { label: RECEIVED_EXPIRED, value: RECEIVED_EXPIRED },
];
export const getReasonCodeOptions_Candy = [
  { label: CANDY_SHORT_SHIPPED, value: CANDY_SHORT_SHIPPED },
  { label: CANDY_OVER_SHIPPED, value: CANDY_OVER_SHIPPED },
];
